var selectedCategoryId = 0;
var initialVisibleNews = 8;
var loadMoreNews = 6;
var visibleNews = initialVisibleNews;
var categoryNews = $('.article-list--item').length;

renderNewsList(categoryNews, initialVisibleNews, selectedCategoryId);

$('#showMore').on('click', function (e) {
    visibleNews += loadMoreNews;
    renderNewsList(categoryNews, visibleNews, selectedCategoryId)
});

function renderNewsList(categoryNews, visibleNews, selectedCategoryId ) {
    var countCategoryNews = 0;

    $('.article-list--item').each(function (index) {
        if (countCategoryNews < visibleNews) {
            $(this).fadeIn();
        } else {
            $(this).fadeOut();
        }
        countCategoryNews++;
    });

    $('.article-list--item').promise().done(() => {
        shouldDisplayMoreNews(countCategoryNews, visibleNews);
    })
}

function shouldDisplayMoreNews(countCategoryNews, visibleNews) {

    if (countCategoryNews > visibleNews) {
        $('#showMore').show();
    } else {
        $('#showMore').hide();
    }
}
